module.exports = __webpack_public_path__ + "static/media/canari_logo_ski.3e6bbfbb.png";